
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import PostLayout from "@src/layouts/PostLayout";
import LazyImage from "@src/components/LazyImage";
import ListBox from "@src/components/ListBox";
import InstaImage from "@src/components/InstaImage";
import LinkWithThumbnail from "@src/components/LinkWithThumbnail";
import { murakamiMasanori } from "@src/constants/authors";
import {
  harajukuUzunaomomMenuUzunaMenuAlcholImage,
  harajukuUzunaomomMenuUzunaMenuTeaImage,
  harajukuUzunaomomMenuUzunaMenuTopImage,
} from "@src/constants/images";
import { meta as pancakePageMeta } from "./pancake.mdx";
import { meta as uzunaomomPageMeta } from "./uzunaomom.mdx";
export const meta = {
  path: "/media/harajuku/uzunaomom_menu",
  title: "【全メニュー】原宿パンケーキ「ウズナオムオム」のメニューを写真付きで公開！",
  description: "原宿パンケーキの名店「ウズナオムオム」のメニューを税込値段、デザートパンケーキ、お食事パンケーキ、ランチメニューなど、全てを写真付きでご紹介させていただきます！メニュー以外にも、支払い方法やアクセスも掲載しているので、是非ご覧ください！",
  topImg: harajukuUzunaomomMenuUzunaMenuTopImage,
  author: murakamiMasanori,
  tags: ["穴場", "有名店", "行列店", "パンケーキ", "おしゃれな内装", "人気店", "お店の紹介", "デート", "女子会", "食べログ高評価", "メニュー詳細"]
};

const layoutProps = {
  meta
};
const MDXLayout = ({ children }) => (
  <PostLayout meta={meta}>{children}</PostLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`原宿パンケーキの名店「ウズナオムオム」のメニューを税込値段、デザートパンケーキ、お食事パンケーキ、ランチメニューなど、全てを写真付きでご紹介させていただきます！`}</p>
    <p>{`インスタグラムに写真がたくさん載っていますが、一覧化されたメニューは中々載っていないので、こちらに全てまとめてみましたので、ご覧いただければと思います！`}</p>
    <h2>{`ウズナオムオム (uzuna omom)`}</h2>
    <InstaImage postId="BsXA8poA5ay" mdxType="InstaImage" />
    <p>{`原宿パンケーキの穴場で、店内がアットホームで落ち着き、パンケーキメニューも豊富な人気店です！
行列になることもありますが、比較的入りやすい穴場的なお店とされています。
そんな、ウズナオムオム (uzuna omom)のメニューについてご紹介します！`}</p>
    <hr></hr>
    <h2>{`デザートパンケーキ`}</h2>
    <p>{`ウズナオムオム(uzuna omom)といえば、インスタ映えするデザートパンケーキメニューが有名！
インスタグラムで、#ウズナオムオム #uzumnaomom と検索すると、たくさんの可愛いパンケーキが出てきます。
で材ーおパンケーキを種類別、写真と税込値段でご紹介させていただきます！`}</p>
    <h3>{`自家製バターでつくるハニーバターレモン(税込：1,100 円)`}</h3>
    <InstaImage postId="BySt-CzAhcq" include={[0]} mdxType="InstaImage" />
    <h3>{`あんずとマスカルポーネチーズ(税込：1,100 円)`}</h3>
    <InstaImage postId="BCNfgQhHZcM" mdxType="InstaImage" />
    <h3>{`自家製キャラメルとバニラアイス(税込：1,210 円)`}</h3>
    <InstaImage postId="B6SAMPFjxqw" mdxType="InstaImage" />
    <h3>{`チョコとラズベリーの３色ホイップ(税込：1,265 円)`}</h3>
    <InstaImage postId="B770O7pnywp" mdxType="InstaImage" />
    <h3>{`ラム香るあつあつバナナソテー(税込：1,210 円)`}</h3>
    <InstaImage postId="BySt-CzAhcq" include={[1]} mdxType="InstaImage" />
    <h3>{`素材を味わうプレーン バター・シロップ付(税込：990 円)`}</h3>
    <InstaImage postId="B4uq0jLA_B4" mdxType="InstaImage" />
    <hr></hr>
    <h2>{`トッピング`}</h2>
    <p>{`ウズナオムオム(uzuna omom)のトッピングは他のお店と異なり、シンプルでわかりやすくなっています！
値段もリーズナブルなので、手が出しやすい！`}</p>
    <ListBox list={["バニラアイス：(税込：110円)", "ホイップクリーム：(税込：110円)", "ドリンクセット：(税込：330円)"]} mdxType="ListBox" />
    <p>{`※セットにできるドリンクは、下のドリンクセットのところで ★ をつけているので、そこでご紹介します！`}</p>
    <hr></hr>
    <h2>{`月替りのパンケーキ`}</h2>
    <p>{`ウズナオムオム(uzuna omom)では毎月メニューが変わるマンスリーパンケーキというものがあります！
いろいろ検索しても見つけづらいと思うのですが、こちらにでご紹介します！`}</p>
    <h3>{`苺とチョコのティラミス風パンケーキ(税込：1,595 円)`}</h3>
    <InstaImage postId="B8mq6GQAx-K" mdxType="InstaImage" />
    <p>{`2020 年 2 月限定で提供されていた人気のパンケーキメニュー！
苺とチョコがバランスよくふんだんに使用され、マスカルポーネなどが入っていて、贅沢なメニューになっています！`}</p>
    <h3>{`桜のパンケーキ(税込：1,595 円)`}</h3>
    <InstaImage postId="B_Y9_ZTALOZ" mdxType="InstaImage" />
    <p>{`2020 年 4 月~5 月にかけて提供されていた人気のパンケーキメニュー！
値段は他のパンケーキと比べて少しお値段が張りますが、こんなおいしそうなパンケーキなら食べてみたいですよね！`}</p>
    <hr></hr>
    <h2>{`原宿本店限定メニュー`}</h2>
    <p>{`フレッシュフルーツとキャラメルの 10 段スペシャルパンケーキ(税込：3960 円)`}</p>
    <p>{`パンケーキにしてはかなり高額な値段ですが、「パンケーキをがっつり食べたい！」「パンケーキなら何枚でも食べられる！」という方はこちらにチャレンジしてみても良いかもしれません！`}</p>
    <hr></hr>
    <h2>{`お食事パンケーキ`}</h2>
    <p>{`ウズナオムオム(uzuna omom)では、塩気のあるお食事系のパンケーキも用意されています！
甘すぎるのが苦手な方は、塩気のある食事系パンケーキメニューがオススメです。`}</p>
    <h3>{`厚切り B.L.T(税込：1220 円)`}</h3>
    <InstaImage postId="B4cDWghBhG0" mdxType="InstaImage" />
    <h3>{`生ハムとクリームチーズ(税込：1265 円)`}</h3>
    <InstaImage postId="B46X-mrA_Xc" mdxType="InstaImage" />
    <h3>{`スモークサーモンとカマンベール(税込：1265 円)`}</h3>
    <InstaImage postId="B78pOl5nzgC" mdxType="InstaImage" />
    <hr></hr>
    <h2>{`ランチ`}</h2>
    <p>{`お食事パンケーキをベースにしたランチメニューもかなり人気なんです！
ウズナオムオム(uzuna omom)では、パンケーキかライスを選べるようになっており、どちらも試せるのが魅力的！`}</p>
    <h3>{`週替わりのランチセット(税込：1,210 円)`}</h3>
    <p><strong parentName="p">{`ライスだとこんな感じに！`}</strong></p>
    <InstaImage postId="BUyRpdiljr8" mdxType="InstaImage" />
    <p><strong parentName="p">{`パンケーキだとだとこんな感じに！`}</strong></p>
    <InstaImage postId="B_088x1AVZn" mdxType="InstaImage" />
    <p>{`その他にもカレーセットやビーフストロガノフセットなどのメニューもあるので、気になる方は食べてみてください…！`}</p>
    <InstaImage postId="B93qRQAAE1N" mdxType="InstaImage" />
    <hr></hr>
    <h2>{`ドリンク`}</h2>
    <p>{`★ がついているものはセットドリンクにできるドリンクになっています！`}</p>
    <h3>{`コーヒー`}</h3>
    <InstaImage postId="B7e9axRgHIc" mdxType="InstaImage" />
    <p>{`質に拘った豆を使用したり、カフェインレスのデカフェコーヒーなどもあるので、お好みに合わせて選んでください…！`}</p>
    <ListBox list={["★堀口珈琲のブレンド(Hot) (税込：550円) / おかわり (税込：330円)", "★アイスコーヒー(Ice) (税込：550円)", "★カフェオレ(Hot/Ice) (税込：660円)", "ウィンナーコーヒー(Hot/Ice)(税込：660円)", "カフェオレ ホイップクリーム(Hot/Ice)(税込：715円)", "★デカフェ(Hot/Ice) (税込：550円)"]} mdxType="ListBox" />
    <h3>{`紅茶`}</h3>
    <LazyImage img={harajukuUzunaomomMenuUzunaMenuTeaImage} mdxType="LazyImage" />
    <ListBox list={["★紅茶(ポットサービス)(Hot) (税込：660円)  ダージリン/アールグレイ", "★アイスティー(Ice)  (税込：550円)", "ルイボスティー(ポットサービス) (Hot)(税込：660円)"]} mdxType="ListBox" />
    <h3>{`その他`}</h3>
    <InstaImage postId="B2vIMd1gjpn" mdxType="InstaImage" />
    <ListBox list={["キャラメルミルク(Hot/Ice) (税込：660円)", "★ミルク(Hot/Ice)  (税込：550円)", "黒ごまバナナオレ(Ice)(税込：715円)", "贅沢レモネード(Hot/Ice) (税込：715円)", "★ジンジャーエール(Ice)  (税込：550円)", "★オレンジジュース (果汁100% )(Ice) (税込：550円)"]} mdxType="ListBox" />
    <h3>{`アルコール`}</h3>
    <LazyImage img={harajukuUzunaomomMenuUzunaMenuAlcholImage} mdxType="LazyImage" />
    <ListBox list={["ビール (税込：550円)", "グラスワイン(赤・白)  (税込：660円)", "ホットワイン  (税込：660円)"]} mdxType="ListBox" />
    <hr></hr>
    <h3>{`おわりに`}</h3>
    <p>{`ウズナオムオム (uzuna omom)のメニューについてご紹介してきましたが、いかがでしたか？
知っているものもあれば、知らなメニューもあったのではないかと思います。ウズナオムオム (uzuna omom)にお越しの際は、是非こちらのメニューを参考にして、素敵な時間をお過ごしください！`}</p>
    <hr></hr>
    <p>{`ウズナオムオムの他の情報に関してはこちら！`}</p>
    <LinkWithThumbnail meta={uzunaomomPageMeta} mdxType="LinkWithThumbnail" />
    <p>{`また、パンケーキの他のお店についてはこちっらのページをご覧ください！`}</p>
    <LinkWithThumbnail meta={pancakePageMeta} mdxType="LinkWithThumbnail" />

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;